import { apiRequest } from "./apiService";

/*
|--------------------------------------------------------------------------
| User session
|--------------------------------------------------------------------------
*/

export async function fetchUserData() {
  const response = await apiRequest("session", "POST");

  if (!response || !response[0]) {
    return {
      isLogged: false,
    };
  }

  const user = response[0];

  return {
    isLogged: true,
    userId: user.userId,
    user: user.user,
    fullName: user.fullName,
    email: user.email,
    group: user.group,
    city: user.city,
    cityName: user.cityName,
    expire: user.expire,
    is_active: user.is_active,
    phone: user.phone,
    veryf: user.veryf,
    email_veryf: user.email_veryf,
    birthyear: user.birthyear,
    type: user.type,
  };
}
